import { render, staticRenderFns } from "./SkillSim.vue?vue&type=template&id=8c9febb6&scoped=true&"
import script from "./SkillSim.vue?vue&type=script&lang=ts&"
export * from "./SkillSim.vue?vue&type=script&lang=ts&"
import style0 from "./SkillSim.vue?vue&type=style&index=0&id=8c9febb6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9febb6",
  null
  
)

export default component.exports